<h3>Version</h3>

<div class="alert alert-info" ng-show="verCtrl.version">
  <h4><i class="fa fa-info-circle"></i> <span ng-bind="verCtrl.version.data"></span> </h4>
</div>

<div class="alert alert-warning" ng-show="verCtrl.error">
  <h4><i class="fa fa-warning"></i> Versionsnummer wurde nicht gefunden: <span ng-bind="verCtrl.error"></span> </h4>
</div>